/**
 * Validates decoder_id checksum. Expects format "REGION-NUMBER".
 * Ported from legacy `check_decoder_id`.
 */
export const checkDecoderId = (decoderId) => {
  const nn = String(decoderId ?? "").split("-");
  if (nn.length !== 2) return false;

  // NOTE: This is legacy bitwise checksum logic used by the backend.
  const id_crc = (nn[1] >>> 0) & 0xff;
  const id = (nn[0] << 24) | (nn[1] >>> 8);

  let crc = 0;
  for (let i = 0; i < 4; i++) {
    crc ^= (id >>> (i * 8)) & 0xff;
    for (let j = 0; j < 8; j++) {
      if ((crc & 0x80) !== 0) crc = (crc << 1) ^ 7;
      else crc <<= 1;
    }
  }

  crc &= 0xff;
  return crc === id_crc;
};

